import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HeadingH1, Flex, Spinner } from '@hausgold/designsystem';
import { ApiContext, WizardContext } from '../utils/contexts.js';
import { STEP_USER_DATA } from '../utils/CONSTANTS.js';
import { getSpinnerDuration, getSpinnerText } from '../services/models/dialog.js';
import FluidMaxContainer from '../components/FluidMaxContainer.js';
import { jsx } from '@emotion/react';
var CalculationStep = function CalculationStep(_ref) {
  var shouldRedirectAfterTimeout = _ref.shouldRedirectAfterTimeout;
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    setCurrentStep = _useContext2.setCurrentStep,
    CalculationLayoutContainer = _useContext2.components.CalculationLayoutContainer;
  useEffect(function () {
    // Do not redirect when `shouldRedirectAfterTimeout` is false.
    if (!shouldRedirectAfterTimeout) {
      return function () {};
    }
    var timeout = setTimeout(function () {
      setCurrentStep(STEP_USER_DATA);
    }, getSpinnerDuration(data) || 5000);

    // Clear timeout when unmounting
    return function cleanup() {
      clearTimeout(timeout);
    };
  }, []);
  return jsx(FluidMaxContainer, null, jsx(CalculationLayoutContainer, null, jsx(HeadingH1, {
    as: "div",
    mb: 12
  }, getSpinnerText(data)), jsx(Flex, null, jsx(Spinner, {
    className: "spinner",
    size: "xl",
    mx: "auto"
  }))));
};
CalculationStep.propTypes = {
  shouldRedirectAfterTimeout: PropTypes.bool
};
CalculationStep.defaultProps = {
  shouldRedirectAfterTimeout: true
};
export { CalculationStep as default };